import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { faqSchema, breadcrumbSchema } from "@/lib/schema";
import { CaretDown } from "@phosphor-icons/react";

export default function FaqPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(-1);
  useEffect(() => { api.get("/faqs").then((r) => setItems(r.data.items)); }, []);
  const grouped = items.reduce((acc, x) => {
    (acc[x.category] = acc[x.category] || []).push(x); return acc;
  }, {});
  const crumbs = [{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }];
  return (
    <div data-testid="faq-page">
      <SEO
        title="Dubai real estate FAQ"
        description="Answers to the most common questions on buying, renting, mortgages, taxes, Golden Visa and off-plan in Dubai."
        path="/faq"
        schema={[breadcrumbSchema(crumbs), faqSchema(items.map((f) => ({ q: f.q, a: f.a })))]}
      />
      <section className="pt-6 pb-14 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={crumbs} />
          <div className="overline text-[#001588] mb-4">FAQ</div>
          <h1 className="font-serif text-5xl lg:text-7xl leading-tight max-w-4xl">Everything you<br/><span className="italic text-neutral-600">wanted to ask.</span></h1>
        </div>
      </section>
      <section className="py-14">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-12 space-y-14">
          {Object.entries(grouped).map(([cat, list]) => (
            <div key={cat}>
              <div className="overline text-[#001588] mb-4">{cat}</div>
              <div className="border-t border-neutral-200">
                {list.map((f) => (
                  <button
                    key={f.id}
                    onClick={() => setOpen(open === f.id ? -1 : f.id)}
                    className="w-full text-left border-b border-neutral-200 py-5"
                    data-testid={`faq-${f.id}`}
                  >
                    <div className="flex items-center justify-between gap-4">
                      <span className="font-serif text-lg text-neutral-900">{f.q}</span>
                      <CaretDown size={16} className={`transition-transform ${open === f.id ? "rotate-180" : ""} text-[#001588]`} />
                    </div>
                    {open === f.id && <div className="text-neutral-700 mt-3 leading-relaxed">{f.a}</div>}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
